"use strict";var r=require("./isArray.cjs"),i=require("./isString.cjs");exports.isStringArray=function(e){return r.isArray(e)&&e.length>0&&e.every(i.isString)};
//# sourceMappingURL=isStringArray.cjs.map
